import { fileIcons } from '../../consts/fileTypes';
import { SFileRender } from './style';

interface FileRenderProps {
  name?: string;
  type?: string;
}

const FileRender = ({ name = '', type }: FileRenderProps) => {
  const Icon = fileIcons[type];
  return (
    <SFileRender
      data-tooltip-id="file-name"
      data-tooltip-content={name}
      data-tooltip-variant="light"
    >
      <Icon />

      <p>{name}</p>
    </SFileRender>
  );
};

export default FileRender;
